module.exports = __webpack_public_path__ + "img/csm_Ersa-POWERFLUX-01-900x675_bd591981e9.6ccf9ecf.png";